import { render, staticRenderFns } from "./ModalAlertWarning.vue?vue&type=template&id=406a20e6&scoped=true&"
import script from "./ModalAlertWarning.vue?vue&type=script&lang=js&"
export * from "./ModalAlertWarning.vue?vue&type=script&lang=js&"
import style0 from "./ModalAlertWarning.vue?vue&type=style&index=0&id=406a20e6&rel=stylesheet&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406a20e6",
  null
  
)

export default component.exports